import { useSubscriptionStatus } from '../useSubscriptionStatus';
import SubscriptionGuard from '../SubscriptionGuard';
import DevssoftChatCore from './DevssoftChatCore';
import DevssoftChatLandingPage from './DevssoftChatLandingPage';

export default function DevssoftChatApp() {
  const { status, daysLeft, expiresAtLabel } = useSubscriptionStatus('devssoft_chat_v1');

  return (
    <SubscriptionGuard
      status={status}
      daysLeft={daysLeft}
      expiresAtLabel={expiresAtLabel}
      landing={<DevssoftChatLandingPage />}
      appKey="devssoft_chat_v1"
      appName="DevsSoft Chat"
    >
      <DevssoftChatCore />
    </SubscriptionGuard>
  );
}
